import { createContext } from 'react';
import type { Route } from 'components/app/routes/app-routes-revamp';

type ResponsiveContextType = {
  isMobile: boolean | null;
  isTablet: boolean | null;
  isDesktop: boolean | null;
};
export const XStateContext = createContext({
});

const defaultResponsiveContext: ResponsiveContextType = {
  isMobile: null,
  isTablet: null,
  isDesktop: null
};

export const ResponsiveContext = createContext(defaultResponsiveContext);


type RouteScreenContext = {
  route: Route | null;
  routes: Route[];
};

export const RouteScreenContext = createContext<RouteScreenContext>({
  route: null,
  routes: []
});
